'use client';

import { TipsenLink } from '@svs/nova-poolbetting/ui/TipsenLink';
import { cn } from '@svs/nova-poolbetting/ui/utils';
import { useMediaQueryAbove } from '@svs/ui/media-query/react';
import { type ComponentProps, type PropsWithChildren, type ReactNode } from 'react';

type CouponRowWrapperProps = PropsWithChildren<{
  defaultQuery: ComponentProps<typeof TipsenLink>['href']['query'];
  queryOnSmallScreen: ComponentProps<typeof TipsenLink>['href']['query'];
  shouldScrollToTop?: boolean;
  className?: string;
}>;

/**
 * Component that wraps the coupon row and handles url query params.
 *
 * @param param0 props
 * @param param0.children the children to pass downs
 * @param param0.defaultQuery query string for large screens and also default query string
 * @param param0.queryOnSmallScreen query string for small screens
 * @param param0.shouldScrollToTop whether to scroll to top on navigation
 * @param param0.className additional class names to apply
 * @returns CouponRowWrapper component
 */
export default function CouponLinkWrapper({
  defaultQuery,
  queryOnSmallScreen,
  children,
  shouldScrollToTop,
  className,
}: CouponRowWrapperProps): ReactNode {
  const isLargeScreen = useMediaQueryAbove('md');

  const query = isLargeScreen ? defaultQuery : queryOnSmallScreen;

  return (
    <TipsenLink
      className={cn(`absolute inset-0 z-1 ${className || ''}`)}
      href={{ query }}
      queriesToKeep="ALL"
      scroll={shouldScrollToTop}
      prefetch={false}
    >
      {children}
    </TipsenLink>
  );
}
